import React from "react";
import NetworkListingPresenter from "./NetworkListing.presenter";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { MapStateToProps, MapDispatchToProps, C_Props, MergedProps, C_States } from "./NetworkListing.type";
import { AppNotifications, BranchOutputModel, RootState, TCb } from "../../../../../models";
import { AllLanguageListActions, NotificationActions } from "../../../../../store/actions";
import _ from "lodash";

import { APP_ROUTES, INITIAL_FETCHING_PAGINATION_DATA } from "../../../../../constants";

import { NetWorkService } from "../../../../../services";
import { loadCallback } from "../../../../../utils";
import { withRouter } from "react-router-dom";

const EMPTY_FILTER: C_States["filter"] = {
  countryId: "",
  searchValue: "",
};

class NetworkListingContainer extends React.Component<MergedProps, C_States> {
  constructor(props) {
    super(props);
    const branchId = this.props.match.params.branchId;

    this.state = {
      filter: EMPTY_FILTER,
      fetchedBranch: INITIAL_FETCHING_PAGINATION_DATA,
      visibleBranchId: branchId,
      visibleBranchForm: Boolean(branchId),
      countries: [],
      visibleUpdatingBlog: null,
      visibleCountryForm: false,
    };
  }

  openBranchFormModal = (branchId?: string) => {
    this.setState({ visibleBranchId: branchId, visibleBranchForm: true }, () => {
    });
  };

  closeBranchFormModal = (cb?: TCb) => {
    this.props.history.push(APP_ROUTES.PAGEMANAGEMENT.NETWORK.BASE);
    this.setState({ visibleBranchId: undefined, visibleBranchForm: false }, () => {
      this.onApplyFilter(false);
      loadCallback(cb?.success);
    });
  };

  openCountryFormModal = () => {
    this.setState({ visibleCountryForm: true });
  };

  closeCountryFormModal = (cb?: TCb) => {
    this.setState({ visibleCountryForm: false }, () => {
      loadCallback(cb?.success);
    });
  };

  onSearch = _.debounce((searchValue: string) => {
    this.setState(
      (prevState) => {
        return {
          filter: {
            ...prevState.filter,
            searchValue,
          },
        };
      },
      () => {
        this.onApplyFilter(false);
      }
    );
  }, 300);

  onChangeCountry = (countryId: string) => {
    this.setState(
      {
        filter: {
          ...this.state.filter,
          countryId,
        },
      },
      () => {
        this.onApplyFilter(false);
      }
    );
  };

  onDeleteCountry = (countryId) => {
    countryId && NetWorkService.deleteCountry(countryId)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Delete country success",
          });
          this.onApplyFilter(false);

          // Xóa filter của country xóa để  không cho phép tạo branch
          this.setState({ 
            filter: {
              ...this.state.filter,
              countryId: ""
            }
          })
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Delete country failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Delete country failed",
        });
      });
  }

  onApplyFilter = async (loadMore: boolean, cb?: TCb) => {
    if (this.state.fetchedBranch.loading && loadMore) return;
    await this.onLoadCoutries();

    this.setState(
      (prevState) => {
        return {
          fetchedBranch: {
            ...prevState.fetchedBranch,
            data: loadMore ? prevState.fetchedBranch.data : [],
            loading: true,
          },
        };
      },
      () => {
        const query: Parameters<typeof NetWorkService.getAllBranchByCountry>[0] = {
          page: loadMore ? this.state.fetchedBranch.page + 1 : 1,
          limit: this.state.fetchedBranch.limit,
          searchValue: this.state.filter.searchValue || undefined,
          countryId: this.state.filter.countryId!,
        };

        this.state.filter.countryId && NetWorkService.getAllBranchByCountry(query)
          .then((res) => {
            if (res && res.data?.data) {
              this.setState(
                (prevState) => {
                  let countryData: BranchOutputModel[] = [...res.data.data];

                  if (loadMore) {
                    countryData.unshift(...prevState.fetchedBranch.data);
                  }

                  return {
                    fetchedBranch: {
                      ...res.data,
                      data: countryData,
                      loading: false,
                    },
                  };
                },
                () => {
                  loadCallback(cb?.success);
                }
              );
            } else {
              this.setState({
                fetchedBranch: INITIAL_FETCHING_PAGINATION_DATA,
              });
            }
          })
          .catch((err) => {
            this.setState({
              fetchedBranch: INITIAL_FETCHING_PAGINATION_DATA,
            });
          });
      }
    );
  };

  onLoadMore = () => this.onApplyFilter(true);

  onLoadCoutries = () => {
    NetWorkService.getAllCountry()
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.setState({ countries: res.data.data });
        }
      })
      .catch((err) => {
        this.setState({
          countries: [],
        });
      });
  };

  onDeleteBranch = (branchId: string | null) => {
    branchId && NetWorkService.deleteBranch(branchId!)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Delete branch success",
          });
          this.onApplyFilter(false);
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Delete branch failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Delete branch failed",
        });
      });
  };

  componentDidMount() {
    if (this.state.visibleBranchId && this.state.visibleBranchForm) {
      // todo nếu vào form detail
    }
    if (!this.props.all_language_list.data.length) {
      this.props.actions.getAllLanguages({
        success: () => {
          this.onApplyFilter(false, {
            success: () => {},
          });
        }
      });
    } else {
      this.onApplyFilter(false, {
        success: () => {},
      });
    }
  }

  render() {
    return (
      <NetworkListingPresenter
        {...this.props}
        {...this.state}
        onChangeCountry={this.onChangeCountry}
        onDeleteCountry={this.onDeleteCountry}
        onLoadMore={this.onLoadMore}
        onSearch={this.onSearch}
        openBranchFormModal={this.openBranchFormModal}
        closeBranchFormModal={this.closeBranchFormModal}
        openCountryFormModal={this.openCountryFormModal}
        closeCountryFormModal={this.closeCountryFormModal}
        reloadListingPage={() => {
          this.onApplyFilter(false);
        }}
        reloadListingCountry={() => {
          this.onLoadCoutries();
        }}
        onDeleteBranch={this.onDeleteBranch}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions, AllLanguageListActions), dispatch),
    })
  )(NetworkListingContainer)
);
